/**
 * Brown Bears Men's Basketball - The Wire Report Data
 * 2025-26 Season | January 20, 2026
 * Offensive Analysis & Scouting Report
 */

export const gameMetadata = {
  fixture: "Brown Bears Offensive Analysis",
  competition: "Ivy League - 2025-26 Season",
  date: "2026-01-20",
  record: "7-10 (1-3 Ivy)",
  venue: "Pizzitola Sports Center (Providence, RI)",
  analysisScope: "Offensive Scheme Analysis + Ball Screen Coverage Guide + Play-by-Play Breakdowns",
  dataFidelity: "Complete TRON report with video-synced play analysis",
  videoUrl: null, // Will be set when video is available
  thumbnailUrl: "/images/brown-bears-thumb.jpg",
  teamColors: {
    primary: "#4E3629", // Brown
    secondary: "#C00404", // Cardinal Red
    accent: "#FFFFFF"
  }
};

// Key moments from video analysis - play-by-play breakdowns
export const keyMoments = [
  {
    id: "km-001",
    timeVideo: "00:09",
    timeSeconds: 9,
    event: "Langham High P&R Pocket Pass",
    category: "playmaking",
    team: "Brown",
    player: "Isaiah Langham (#1)",
    analysis: "Langham calls for a high ball screen from Dabo. He attacks the right elbow aggressively, drawing help defense inward. Recognizing the defensive collapse, he threads a precise pocket bounce pass to Dabo rolling hard to the rim. Excellent patience to string out the hedge and wait for the passing lane.",
    defensiveResponse: "Hard Hedge / Blitz - Penn big man steps out hard but slow to recover. Tag defender from weak side late to obstruct roller's lane.",
    result: "Made Layup (#45 Dabo)",
    confidence: 0.95,
    icon: "assist"
  },
  {
    id: "km-002",
    timeVideo: "00:15",
    timeSeconds: 15,
    event: "Jenkins High P&R Creation",
    category: "playmaking",
    team: "Brown",
    player: "Jeremah Jenkins (#3)",
    analysis: "Jenkins uses a high ball screen to attack the right side. Reads aggressive positioning of opposing big, delivers precise pocket bounce pass to the rolling big man. Roller catches on short roll, takes one power dribble to compose, finishes at rim.",
    defensiveResponse: "Hard Hedge / Blitz - Penn big hedges hard, stays too high. Weakside tagger (#11) stays attached to corner shooter, leaving paint exposed.",
    result: "Made Layup (Dabo)",
    confidence: 0.92,
    icon: "assist"
  },
  {
    id: "km-003",
    timeVideo: "00:22",
    timeSeconds: 22,
    event: "Jenkins Transition Alley-Oop",
    category: "clutch",
    team: "Brown",
    player: "Jeremah Jenkins (#3)",
    analysis: "In semi-transition, Jenkins utilizes a drag screen at the top of the key. Seeing the defensive big in deep drop, attacks downhill with speed to freeze defender. Lofts perfectly timed alley-oop to Dabo rolling behind defense. When defense drops deep, attacking with pace puts big in '2-on-1' bind.",
    defensiveResponse: "Deep Drop - Defensive big drops all the way to restricted area, conceding too much space, fails to get hand up to deter lob pass.",
    result: "Made Dunk (Alley-oop to Dabo)",
    confidence: 0.96,
    icon: "dagger"
  },
  {
    id: "km-004",
    timeVideo: "00:29",
    timeSeconds: 29,
    event: "Lilly Rejects Screen",
    category: "drive",
    team: "Brown",
    player: "Kino Lilly Jr. (#10)",
    analysis: "Ball handler sees defender jumping to screen side early. Immediately rejects the screen, driving hard to baseline. Creates 2-on-1 in the lane, forces help to commit to ball, leaving screener (who slipped to rim) open for dump-off. Great read to reject - when defender cheats alignment, attack open lane.",
    defensiveResponse: "Ice / Side - On-ball defender tried to force ball handler into screen but got beat on rejection. Help rotation from baseline was late.",
    result: "Made Layup",
    confidence: 0.91,
    icon: "drive"
  },
  {
    id: "km-005",
    timeVideo: "01:03",
    timeSeconds: 63,
    event: "Lilly vs Blitz - Short Roll",
    category: "playmaking",
    team: "Brown",
    player: "Kino Lilly Jr. (#10)",
    analysis: "Defense aggressively double-teams (blitzes) ball handler off screen. Guard stays calm, retreats slightly to improve passing angle, hits short-rolling big in middle of floor (the 'release valve'). Big catches and makes play 4-on-3. Against blitz, short roll is most dangerous weapon.",
    defensiveResponse: "Blitz / Trap - Both defenders commit to ball handler. Rotations too slow to cover rolling big in middle of paint.",
    result: "Made Layup (Assist to finish)",
    confidence: 0.93,
    icon: "assist"
  },
  {
    id: "km-006",
    timeVideo: "01:28",
    timeSeconds: 88,
    event: "Jenkins Clutch Lob",
    category: "clutch",
    team: "Brown",
    player: "Jeremah Jenkins (#3)",
    analysis: "Crucial late-game moment (1-point game). Jenkins calls for high screen with floor spaced (shooters in corners). Attacks drop coverage, throws perfect lob over the top to Dabo. Vertical spacing (the lob) is as valuable as horizontal spacing in clutch situations.",
    defensiveResponse: "Drop Coverage - Defender (#33) backpedals worried about drive, fails to tag roller. Weakside defenders glued to shooters, no help at rim.",
    result: "Made Dunk (Alley-oop)",
    confidence: 0.97,
    icon: "clutch"
  },
  {
    id: "km-007",
    timeVideo: "05:32",
    timeSeconds: 332,
    event: "Lilly Snake vs Providence",
    category: "drive",
    team: "Brown",
    player: "Kino Lilly Jr. (#10)",
    analysis: "Late shot clock against Providence. Guard uses screen and snakes/refuses to keep defender on hip. Draws big defender up and slips pocket pass to roller (#23) who finishes through contact. Change of pace kept big defender guessing; decisive passing in tight windows is critical against high-major length.",
    defensiveResponse: "Drop - Providence big caught flat-footed, steps up too late to stop ball, out of position to recover to roller.",
    result: "Made Layup (And-One possibility)",
    confidence: 0.88,
    icon: "drive"
  },
  {
    id: "km-008",
    timeVideo: "06:50",
    timeSeconds: 410,
    event: "Jenkins DHO Execution",
    category: "playmaking",
    team: "Brown",
    player: "Jeremah Jenkins (#3)",
    analysis: "Jenkins passes to big (#31) at top of key and immediately sprints into Dribble Handoff. Curls tightly around big man, turning corner and forcing defensive big to step up. Creates passing window for pocket pass to #31 rolling to rim. Curling tight off DHO shoulder is crucial - prevents trailing defender from shooting gap.",
    defensiveResponse: "Drop Coverage - Defender on ball trails over screen, big defender steps up to contain but leaves roller unaccounted for.",
    result: "Made Layup (#31)",
    confidence: 0.90,
    icon: "assist"
  },
  {
    id: "km-009",
    timeVideo: "07:34",
    timeSeconds: 454,
    event: "Lilly Chicago Action",
    category: "playmaking",
    team: "Brown",
    player: "Kino Lilly Jr. (#10)",
    analysis: "Play starts with #10 coming off pindown screen on wing, flows directly into DHO with big (#31) at top of key. Momentum from initial screen allows #10 to blow past trailing defender. Drives into paint, drops bounce pass to rolling big. Using off-ball screen BEFORE on-ball action (Chicago action) puts defender in trail position.",
    defensiveResponse: "Trailing - Defender forced to chase over top of both screens, out of position to contest drive or pass.",
    result: "Made Layup (#31)",
    confidence: 0.94,
    icon: "assist"
  },
  {
    id: "km-010",
    timeVideo: "09:21",
    timeSeconds: 561,
    event: "Jenkins Pull-Up 3 vs Under",
    category: "shooting",
    team: "Brown",
    player: "Jeremah Jenkins (#3)",
    analysis: "Jenkins brings ball up, calls for high ball screen. Recognizes defender cheating by going UNDER the screen. Instead of driving, uses screen to create separation and immediately pulls up for rhythm 3-pointer. Against 'under' coverage, ball handler must be willing to shoot behind screen to punish defense.",
    defensiveResponse: "Under Coverage - Defender attempts to go under screen to cut off drive but fails to contest shot.",
    result: "Made 3-Pointer",
    confidence: 0.89,
    icon: "shooting"
  }
];

// Player analysis based on TRON personnel breakdown
export const playerAnalysis = [
  {
    player: "Jeremah Jenkins",
    number: "#2",
    team: "Brown",
    position: "G | 6'2\" | SO",
    role: "Primary Initiator / Floor General",
    image: "/images/players/jenkins.jpg",
    stats: {
      ppg: 8.9,
      apg: 5.4,
      fg: "34.7%",
      threePt: "47.4%",
      spg: 2.2
    },
    biomechanics: {
      ballHandling: "First freshman to start season opener since 2017-18. Excellent court vision when probing with dribble.",
      finishing: "Struggles finishing through contact - limited size affects conversion rate at rim.",
      passingAngles: "Elite pocket pass timing on PnR, reads defensive positioning to find rollers in tight windows.",
      decisionMaking: "Patient to string out hedges before delivering passes. Creates for others rather than forcing own shot."
    },
    tacticalImpact: "The engine of Brown's offense. High assist rate reflects system reliance on his creation. Must be pressured into scoring role to limit his playmaking.",
    scoutingNote: "DEFENSIVE KEY: Force left, make him score over help. Limited as scorer (34.7% FG).",
    csvReference: "TRON Primary Ball Handler Analysis"
  },
  {
    player: "Isaiah Langham",
    number: "#11",
    team: "Brown",
    position: "G | 6'5\" | FR",
    role: "Secondary Creator / Emerging Scorer",
    image: "/images/players/langham.jpg",
    stats: {
      ppg: 10.5,
      fg: "42.2%",
      size: "6'5\", 210 lbs"
    },
    biomechanics: {
      scoring: "Can score at all three levels - versatile offensive threat.",
      transition: "Most dangerous in transition - uses length and athleticism effectively.",
      screenReads: "Growing into ball-screen reads, improving recognition of defensive coverages.",
      physique: "Positional versatility due to 6'5\" frame with 210 lbs - can guard multiple positions."
    },
    tacticalImpact: "Highest-rated recruit (52nd nationally at SG). 1,000+ career points at Belmont Hill. Instant offense off bench or as starter.",
    scoutingNote: "DEFENSIVE KEY: Physical on screens, no clean looks in transition. Contest everything.",
    csvReference: "TRON Secondary Creator Analysis"
  },
  {
    player: "N'famara Dabo",
    number: "#30",
    team: "Brown",
    position: "F/C | 6'8\" | JR",
    role: "Rim-Runner / Interior Finisher / Shot Blocker",
    image: "/images/players/dabo.jpg",
    stats: {
      ppg: 10.2,
      rpg: 7.2,
      fg: "77.3%",
      bpg: 1.9,
      threePtAttempts: 0
    },
    biomechanics: {
      rimRunning: "Elite roll threat - excellent hands in short-roll situations. Finishes through contact.",
      rebounding: "Team leader in rebounds (7.2 RPG). Active on offensive glass when Tavares contests.",
      shotBlocking: "Anchor defensively with 1.9 BPG. 5+ blocks in 4 separate games last season.",
      limitation: "ZERO 3PT attempts - complete non-shooter from perimeter."
    },
    tacticalImpact: "Primary lob target on all high PnR actions. DROP COVERAGE IS VIABLE against him - cannot punish from mid-range. Elite efficiency (77.3% FG) comes exclusively at rim.",
    scoutingNote: "DEFENSIVE KEY: Verticality at rim, no easy dunks. Let him shoot if he ever attempts it.",
    csvReference: "TRON Interior Threat Analysis"
  },
  {
    player: "Landon Lewis",
    number: "#1",
    team: "Brown",
    position: "F | 6'7\" | SR",
    role: "Versatile Scorer / Experienced Leader",
    image: "/images/players/lewis.jpg",
    stats: {
      ppg: "Variable (26 vs Columbia OT)",
      fg: "47.6% (57.3% last year)",
      rpg: "Strong"
    },
    biomechanics: {
      postGame: "Can post smaller defenders - uses physicality to create deep position.",
      faceUp: "Slight regression in efficiency (47.6% vs 57.3% last year) suggests shot selection issues.",
      experience: "Started 22 of 23 games last season. Double-figure scorer in 19 of 23 appearances.",
      clutch: "Career-high 26 points vs Columbia in OT - steps up in big moments."
    },
    tacticalImpact: "Go-to option in late-clock situations and ATO plays. Experience makes him reliable when offense stalls.",
    scoutingNote: "DEFENSIVE KEY: Don't let him get deep position, contest early. No switches with smaller guards.",
    csvReference: "TRON Veteran Scorer Analysis"
  },
  {
    player: "Brady Loughlin",
    number: "#10",
    team: "Brown",
    position: "G | 6'5\" | FR",
    role: "Catch-and-Shoot Specialist",
    image: "/images/players/loughlin.jpg",
    stats: {
      threePt: "38.1% (8/21)",
      hsThreePt: "40%+ all 4 years"
    },
    biomechanics: {
      shooting: "BEST SHOOTER on team - proven stroke from high school (40%+ all 4 years).",
      relocation: "Relocates effectively off ball - always finds open space on kick-outs.",
      release: "Quick release allows catch-and-shoot in tight windows."
    },
    tacticalImpact: "Primary spacing threat from deep. Must be respected on rotations - leaving him open is costly.",
    scoutingNote: "DEFENSIVE KEY: Close out under control, contest with length. Cannot leave him open.",
    csvReference: "TRON Shooter Analysis"
  },
  {
    player: "Kino Lilly Jr.",
    number: "#10",
    team: "Brown",
    position: "G | 6'2\"",
    role: "Ball Handler / DHO Specialist",
    image: "/images/players/lilly.jpg",
    stats: {},
    biomechanics: {
      dhoExecution: "Expert at curling tight off DHO shoulder - turns corner instantly.",
      screenRejection: "Excellent at reading defenders cheating to screen side - rejects and attacks.",
      paceChange: "Uses change of pace to freeze big defenders, creates decisive passing windows.",
      snakeMove: "Effective snake/refuse technique keeps defender on hip."
    },
    tacticalImpact: "Chicago action specialist - uses off-ball screen before on-ball action to get defender trailing.",
    scoutingNote: "Watch for DHO series and Chicago action - he exploits defenders in trail position.",
    csvReference: "TRON DHO Specialist Analysis"
  },
  {
    player: "Adrian Uchidiuno",
    number: "#5",
    team: "Brown",
    position: "G | 6'2\" | SO",
    role: "Energy Guard / Bench Scorer",
    image: "/images/players/uchidiuno.jpg",
    stats: {
      ppg: 10.9,
      fg: "32.5%",
      threePt: "28.6%"
    },
    biomechanics: {
      volume: "Takes a lot of shots (team-high attempts) - high usage from bench.",
      streaky: "Can get hot from deep despite poor percentages (28.6% 3PT).",
      efficiency: "INEFFICIENT scorer - 32.5% FG indicates shot selection issues."
    },
    tacticalImpact: "High-risk, high-reward bench option. Let him shoot contested, help off him on defense.",
    scoutingNote: "DEFENSIVE KEY: Let him shoot contested, help off. Poor percentages make him lowest priority.",
    csvReference: "TRON Bench Scorer Analysis"
  }
];

// Tactical breakdown based on TRON scheme analysis
export const tacticalBreakdown = {
  brownOffense: {
    scheme: "4-Out / 5-Out Motion - Ball Screen Heavy",
    philosophy: "Less pattern-oriented, more random. Continuity ball screens over rigid set plays. Matchup-driven decisions. Harder to scout due to motion concepts.",
    primaryAction: "Drag/Step-Up Ball Screen",
    execution: "Guards probe with dribble, looking to attack hedges and find rollers. Multiple decision points at each stage.",
    keyActions: [
      { action: "Drag/Step-Up Ball Screen", frequency: "HIGH", efficiency: "Medium", notes: "Primary half-court entry" },
      { action: "Empty-Side PnR", frequency: "HIGH", efficiency: "Medium", notes: "Creates drive lanes" },
      { action: "Ghost Screens", frequency: "MEDIUM", efficiency: "Variable", notes: "Deception plays" },
      { action: "Get Action (Handoff)", frequency: "MEDIUM", efficiency: "Medium", notes: "Guard-to-big exchange" },
      { action: "DHO Series", frequency: "MEDIUM", efficiency: "Low-Medium", notes: "Perimeter creation" },
      { action: "Chicago Action", frequency: "MEDIUM", efficiency: "High", notes: "Pindown into DHO" },
      { action: "Horns Entry", frequency: "LOW-MEDIUM", efficiency: "Medium", notes: "Double-screen options" }
    ],
    strengths: [
      "Multiple decision points make it harder to scout",
      "Guards can create advantage in PnR",
      "Bench shooters stretch to NBA range"
    ],
    weaknesses: [
      "No dominant post scorer",
      "Limited rim pressure when first action fails",
      "Possessions can stall into late-clock ISOs"
    ],
    efficiency: "Below Average (105.4 ORTG - 7th in Ivy)"
  },
  brownTransition: {
    scheme: "Push Pace / Early Offense",
    primaryBreak: "Push for layup or early 3",
    secondaryBreak: "Drag screen immediately if numbers aren't advantageous",
    earlyOffense: "4-out spacing, probe with dribble",
    counter: "Sprint back - no easy baskets. Set defense early."
  },
  ballScreenCoverage: {
    title: "Recommended Coverage by Handler",
    byHandler: [
      { handler: "Jenkins", coverage: "Soft Hedge/Drop", rationale: "Limited finishing, force floaters" },
      { handler: "Langham", coverage: "Switch/Hard Hedge", rationale: "Athletic, can attack both ways" },
      { handler: "Uchidiuno", coverage: "ICE/Drop", rationale: "Below-average shooter, limit driving lanes" },
      { handler: "Wrisby-Jefferson", coverage: "Deep Drop", rationale: "Non-threat, pack the paint" }
    ],
    byScreener: [
      { screener: "Dabo", coverage: "DROP", rationale: "Can't shoot, verticality at rim" },
      { screener: "Lewis", coverage: "SOFT/SWITCH", rationale: "More versatile, can face up" }
    ]
  },
  keyReads: {
    emptySide: {
      tendency: "Ball handler attacks downhill, shooter lifts behind ball, big short-rolls or slips",
      counter: "X-out rotation, stay attached"
    },
    getAction: {
      tendency: "Guard sprints for handoff from trailing big, creates quick rhythm shots",
      counter: "Jump the handoff, deny the catch"
    }
  }
};

// Bench dynamics and coaching tendencies
export const benchDynamics = {
  brown: {
    energyCurve: "Variable - depends on shooting night",
    coaching: {
      name: "Mike Martin",
      tenure: "13th season",
      philosophy: "Defensive-first mentality. Offense built on defensive stops and transition.",
      substitution: "Heavy bench usage (8+ players), matchup-driven",
      adjustments: "Will switch to 5-out if interior is clogged",
      timeouts: "Calls them to stop runs, prefers ATO plays that mirror normal offense",
      pressBreak: "Rarely presses, prefers half-court grind"
    },
    frustrationSignals: "Struggles against physical, switching defenses and teams with length at guard positions"
  },
  opponent: {
    howToExploit: [
      "Physical, switching defenses disrupt their timing",
      "Length at guard positions bothers their creators",
      "Pack the paint - dare them to shoot (32.6% from three)"
    ],
    howTheySucceed: [
      "Drop coverage that allows pull-ups",
      "Smaller lineups they can post",
      "Teams that over-help on drives"
    ]
  }
};

// Recommendations based on TRON defensive game plan
export const recommendations = [
  {
    team: "Opponent",
    focus: "Pack the Paint",
    priority: "high",
    action: "Dabo is their only interior threat and he can't shoot. Clog the lane, force perimeter shots. Brown shoots 32.6% from three."
  },
  {
    team: "Opponent",
    focus: "Force Contested 3s",
    priority: "high",
    action: "Let them fire away with a hand up. They're a 32.6% 3PT shooting team - volume of contested threes is acceptable."
  },
  {
    team: "Opponent",
    focus: "Deny Transition",
    priority: "high",
    action: "Their best offense comes in semi-transition (drag screens, early lobs to Dabo). Sprint back on every possession."
  },
  {
    team: "Opponent",
    focus: "Physical on Screens",
    priority: "medium",
    action: "Make Jenkins and Langham work for space. Physical contact on screens disrupts their timing and read progressions."
  },
  {
    team: "Opponent",
    focus: "Personnel Assignments",
    priority: "medium",
    action: "Best perimeter defender on Langham (full deny, physical). Strong guard on Jenkins (force left, contain). Length on Loughlin (contest 3s). Physical big on Dabo (verticality, no dunks). Switchable forward on Lewis (no deep post)."
  }
];

// Ivy League context
export const ivyLeagueContext = {
  standings: {
    record: "7-10 (1-3 Ivy)",
    rank: "8th in Ivy League"
  },
  recentResults: [
    { opponent: "Yale", date: "1/5", result: "L 70-53", notes: "Poor shooting, couldn't generate clean looks" },
    { opponent: "Penn", date: "1/10", result: "L 81-73", notes: "Better but Penn's length disrupted actions" },
    { opponent: "Columbia", date: "1/17", result: "W 86-80 OT", notes: "Lewis 26 pts, won at FT line in OT" },
    { opponent: "Cornell", date: "1/19", result: "L 89-67", notes: "Blown out, couldn't match Cornell's firepower" }
  ],
  keyStats: {
    ppg: { value: 72.6, rank: "8th", context: "Bottom third D-I" },
    fg: { value: "44.4%", rank: "6th", context: "League average" },
    threePt: { value: "33.7%", rank: "8th", context: "Below average" },
    ft: { value: "70.8%", rank: "4th", context: "Adequate" },
    offReb: { value: "11.0/game", rank: "3rd", context: "Solid" },
    bpg: { value: "4.29", rank: "1st", context: "Strong interior D" },
    ortg: { value: 105.4, rank: "7th", context: "Sub-1 PPP" }
  }
};

// Translations (English only for now)
export const translations = {
  en: {
    title: "THE WIRE",
    subtitle: "Brown Bears Offensive Analysis",
    fixture: "Analysis",
    finalScore: "Record",
    venue: "Venue",
    keyMoments: "Key Plays",
    playerAnalysis: "Personnel Breakdown",
    tacticalBreakdown: "Scheme Analysis",
    recommendations: "Defensive Game Plan",
    benchDynamics: "Coaching Tendencies",
    officiating: "Ball Screen Coverage",
    playVideo: "Play Video",
    pause: "Pause",
    stepForward: "Step Forward",
    stepBack: "Step Back",
    frameByFrame: "Frame by Frame",
    analyzing: "Analyzing...",
    chatPlaceholder: "Ask about Brown's offense...",
    send: "Send"
  }
};

// LLM-enhanced pattern predictions
export const patternPredictions = {
  highProbabilitySequences: [
    "Drag Screen → Drive → Kick to Corner → Swing → Re-screen",
    "Empty-Side PnR → Short Roll → High-Low Look",
    "DHO → Reject Screen → Drive Middle → Dump-off",
    "Chicago Action (Pindown → DHO) → Drive → Roller finish"
  ],
  vulnerabilityWindows: [
    "First 8 seconds of shot clock: Predictable entries",
    "After made baskets: Slower pace, more half-court",
    "Late clock: ISO tendencies increase turnover risk",
    "Against press: Limited ball-handlers beyond Jenkins"
  ],
  situationalPredictions: [
    { situation: "Need a 3", action: "Loughlin pin-down", confidence: "HIGH" },
    { situation: "Need a deuce", action: "Lewis post-up", confidence: "MEDIUM" },
    { situation: "Final shot", action: "Langham ISO", confidence: "MEDIUM" },
    { situation: "Jump ball play", action: "Drag screen for Jenkins", confidence: "HIGH" }
  ]
};

// Harvard Defensive Scouting — Attacking Harvard's Defense
export const harvardDefensiveScouting = {
  opponent: 'Harvard Crimson',
  analysisDate: '2026-02-10',
  priority: 'URGENT',

  // 1. Attacking Harvard's Switching Defense
  switchingDefense: {
    title: "Attacking Harvard's Switching Defense",
    description: "Harvard runs a switching man-to-man defense that attempts to eliminate screening advantage by switching all assignments on contact.",
    onBall: [
      {
        concept: 'Hunt the Mismatch — Guard vs Big',
        action: 'After the switch, immediately ISO the big defender in space. Jenkins should attack with speed — Harvard bigs cannot stay in front laterally.',
        personnel: 'Jenkins/Langham vs Harvard Big',
        priority: 'high'
      },
      {
        concept: 'Hunt the Mismatch — Big vs Guard',
        action: 'On the back end of the switch, Dabo (6\'8", 77.3% FG) immediately seals the smaller guard and calls for the entry pass. Duck-in post-ups with deep position.',
        personnel: 'Dabo vs Harvard Guard',
        priority: 'high'
      },
      {
        concept: 'DHO with Re-Screen',
        action: 'First DHO forces switch; immediately re-screen with same big to force a SECOND switch back — creates confusion and scrambles assignments.',
        personnel: 'Jenkins/Lilly + Big (#31)',
        priority: 'medium'
      },
      {
        concept: 'Ghost Screen → Drive',
        action: 'Fake the screen — Harvard defender switches anyway on air → ball handler has an open lane to attack.',
        personnel: 'Langham (speed advantage)',
        priority: 'medium'
      },
      {
        concept: 'Transition Drag Screen',
        action: 'Push pace. Harvard\'s switch communication breaks down in transition. Drag screen into lob that Brown already runs (see [00:22]) is devastating because the switch hasn\'t been communicated yet.',
        personnel: 'Jenkins + Dabo (lob opportunity)',
        priority: 'high'
      }
    ],
    offBall: [
      {
        concept: 'Cross Screens for Dabo',
        action: 'Set cross screen for Dabo in the lane. When Harvard switches, Dabo\'s man (a guard after switch) is sealed under the basket. Lob or high-low entry.',
        priority: 'high'
      },
      {
        concept: 'Elevator Screens',
        action: 'Two bigs at elbows, guard cuts between. Both bigs close like "elevator doors." If Harvard switches, shooter is free in the gap.',
        priority: 'medium'
      },
      {
        concept: 'Pin-Down + Flare for Loughlin',
        action: 'Pin-down for Loughlin (38.1% 3PT). If they switch, his new defender is a slower big — Loughlin curls for mid-range or drives by the bigger, slower defender.',
        priority: 'high'
      },
      {
        concept: 'Chicago Action (Double Switch)',
        action: 'Brown already excels at this (see [07:34]). Pindown → DHO forces TWO switches. By the second action, Harvard\'s assignments are scrambled.',
        priority: 'high'
      }
    ]
  },

  // 2. Attacking Harvard's Diamond / 2-1-2 Zone
  diamondZone: {
    title: "Attacking Harvard's 2-1-2 / Diamond Zone",
    description: "Center at FT line, 1 guard at top of key, 2 guards on wings, 1 forward under the basket.",
    alignment: {
      top: '1 Guard',
      wings: '2 Guards',
      ftLine: 'Center',
      underBasket: '1 Forward'
    },
    vulnerabilities: [
      'High post / FT line area — Center can\'t cover both high post AND short corner',
      'Short corners — Forward under basket can\'t cover both sides; wing guards too high to help',
      'Corner 3s — Wing guards must choose between wing and corner; can\'t cover both',
      'Ball reversal — Diamond zones are slow to shift side-to-side; top guard is alone'
    ],
    attackingConcepts: [
      {
        name: 'Overload Short Corner',
        description: 'Place player in short corner to draw under-basket forward. Flash another player to opposite block — center at FT line can\'t recover.',
        play: 'Jenkins top, Loughlin corner (3PT threat), Lewis short corner, Dabo flash opposite block, Langham weak-side wing',
        priority: 'high'
      },
      {
        name: 'High-Low Action',
        description: 'Passer at FT line (where Harvard\'s center plays), finisher on block. Center must choose: guard ball or protect rim? Either way, advantage Brown.',
        play: 'Lewis/Big #31 catches high post → Dabo dives to rim for high-low pass. If center drops, high post has 15-footer.',
        priority: 'high'
      },
      {
        name: 'Ball Reversal + Skip Pass',
        description: 'Diamond zone\'s biggest weakness is lateral movement. Single top guard can\'t cover both wings. After 2-3 reversals, weak-side corner is WIDE OPEN.',
        play: 'Station Loughlin in skip-pass corner — best shooter (38.1%). Swing wing→top→wing quickly.',
        priority: 'high'
      },
      {
        name: 'Dribble Penetration from Wing',
        description: 'Wing guards cover a large area. Langham (6\'5") drives baseline → under-basket forward helps → kick to short corner or lob to Dabo.',
        play: 'Langham drives baseline, kick to Lewis in short corner or lob to Dabo cutting to vacated basket.',
        priority: 'medium'
      }
    ],
    zoneBeaterPlays: [
      { name: 'Fist Down', entry: '1-4 High', action: 'Flash to FT line, hi-lo to block', target: 'Dabo at rim' },
      { name: 'Corner', entry: 'Horns', action: 'Ball reversal, skip to corner', target: 'Loughlin for 3' },
      { name: 'Short', entry: 'Motion', action: 'Overload short corner, flash opposite', target: 'Lewis/Dabo' },
      { name: 'Gap', entry: 'Spread', action: 'Dribble penetrate wing gap, kick', target: 'Loughlin corner 3' }
    ]
  },

  // 3. Attacking Harvard's Zone OOB Defense
  zoneOOB: {
    title: "Attacking Harvard's Zone Out-of-Bounds Defense",
    blob: [
      {
        name: 'Box Zipper',
        formation: 'Box (2 on blocks, 2 at elbows)',
        inbounder: 'Jenkins (best passer)',
        action: 'Dabo screens ACROSS zone for Lewis → Lewis cuts ball-side block. Loughlin zippers from weak-side elbow to top of key (above zone).',
        reads: [
          'Read 1: Lewis on block if zone collapses → entry pass for layup',
          'Read 2: Loughlin popping to 3PT line if zone stays compact → skip for open 3',
          'Read 3: Dabo seals after screening → lob to rim'
        ],
        priority: 'high'
      },
      {
        name: 'Stack',
        formation: 'Stack all 4 on ball-side block',
        inbounder: 'Jenkins',
        action: 'Two players break to opposite corners, one flashes high, one stays. Zone defenders must decide who goes where — creates confusion.',
        reads: ['Best against zone overloading ball-side'],
        priority: 'medium'
      },
      {
        name: 'Screen the Zone',
        formation: 'Standard box',
        inbounder: 'Jenkins',
        action: 'Dabo screens the under-basket forward\'s zone AREA (not man). Creates gap for cutter to flash to rim behind screen. Zone defender screened off their responsibility.',
        reads: ['Cutter to rim for layup', 'If zone adjusts, kickout to perimeter'],
        priority: 'medium'
      }
    ],
    slob: [
      {
        name: 'Line',
        formation: '4 players across FT line extended',
        action: '#1 and #4 split to corners, #2 cuts to ball, #3 pops to top. Quick pass to #2 → drives gap before zone sets. If zone adjusts, reversal to #3 → skip to open corner.',
        priority: 'medium'
      }
    ],
    keyPrinciple: 'Against zone OOB, the FIRST PASS must be quick and go to the MIDDLE of the zone. Once the ball is center of the zone, every defender is equidistant — they can\'t all close out.'
  },

  // 4. Additional Offensive Ideas
  additionalIdeas: [
    {
      concept: 'Push Transition Before Zone Sets',
      description: 'Harvard can\'t play zone if Brown pushes the ball. Semi-transition offense (drag screens, early lobs to Dabo) is the best weapon. Run. Every. Possession.',
      priority: 'high',
      reference: 'See [00:22] in existing film'
    },
    {
      concept: 'Offensive Rebound During Scheme Changes',
      description: 'When Harvard switches man→zone (or vice versa), there\'s a 1-2 second window of confusion. Crash the glass. Dabo (7.2 RPG) should be especially aggressive.',
      priority: 'medium'
    },
    {
      concept: '5-Out Against Diamond Zone',
      description: 'Go 5-OUT alignment — every zone defender must guard a perimeter player. Eliminates under-basket forward advantage. Even Dabo standing at 3PT line stretches the zone.',
      priority: 'medium'
    },
    {
      concept: 'Let Jenkins Read & React',
      description: 'Jenkins (5.4 APG, 47.4% 3PT) is at his best reading in real-time. Spread alignment, ball at top of key. Drive if big switches on. Lob if Dabo guarded by guard. Kick to Loughlin. Pull up for 3 if they go under.',
      priority: 'high'
    },
    {
      concept: 'Timeout After Scheme Changes',
      description: 'Harvard switches between man and zone in-game. Call timeout immediately when you see the switch to zone — set up zone offense. First possession after scheme change is when zone is most vulnerable.',
      priority: 'medium'
    },
    {
      concept: 'Ball Screen at Top of Zone',
      description: 'Run ball screen at TOP of Diamond zone where only 1 guard defends. Zone guard can\'t hedge/blitz like man — must stay in zone. Gives Jenkins/Langham clean pull-up or driving lane.',
      priority: 'high'
    }
  ],

  // Game Plan Priority Summary
  gamePlanPriority: [
    { rank: 1, action: 'Push pace — transition before zone sets', against: 'All Harvard D', result: 'Easy baskets, lob opportunities' },
    { rank: 2, action: 'Hunt mismatches after switches — Dabo post-up, Jenkins ISO', against: 'Switch Man D', result: 'High-% looks at rim and FT line' },
    { rank: 3, action: 'Overload short corner + skip to Loughlin', against: 'Diamond Zone', result: 'Open corner 3s' },
    { rank: 4, action: 'High-low action (FT line to block)', against: 'Diamond Zone', result: 'Dabo rim finishes' },
    { rank: 5, action: 'Zone OOB — "Box Zipper" BLOB play', against: 'Zone OOB', result: 'Quick-hitter scores' },
    { rank: 6, action: 'Ball reversal (2-3 quick passes)', against: 'Diamond Zone', result: 'Weak-side open shots' }
  ]
};

// Export all data
export default {
  gameMetadata,
  keyMoments,
  playerAnalysis,
  tacticalBreakdown,
  benchDynamics,
  recommendations,
  ivyLeagueContext,
  translations,
  patternPredictions,
  harvardDefensiveScouting
};
